import { h, Component } from "preact";
import { css } from "emotion";
import Button from "../../components/Button";
import { hexToRgba } from "../../utils/Format";

const styles = {
  wrapper: css`
    display: flex;
    width: 100%;
    margin-top: 16px;
    flex-wrap: wrap;
    justify-content: space-between;
    @media (max-width: 600px) {
      margin-left: 14px;
      margin-right: 14px;
      margin-top: 0px;
    }
  `,
  container: css`
    max-width: 480px;
    width: 100%;
    height: 240px;
    position: relative;
    margin-top: 32px;
    margin-bottom: 48px;
    @media (max-width: 600px) {
      margin-top: 12px;
      margin-bottom: 48px;
    }
  `
};

/**
 * Display tour groups
 *
 * @param {*} props
 * @returns
 */
const TourGroup = props => {
  const { theme, slug, preview, token = null } = props;
  let { groups } = props;
  groups = groups.filter(group => !group.deleted);
  const customStyles = {
    contents: css`
      max-width: 300px;
      height: 120px;
      width: 100%;
      position: absolute;
      bottom: -32px;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      background: ${hexToRgba(
        theme.eventCardBackgroundColor,
        theme.cardAndBarOpacity
      )};
      text-align: center;
      padding-top: 16px;
      border-radius: 4px;
      box-shadow: 0 1px 4px 0 rgba(9, 30, 66, 0.13);
    `,
    title: css`
      font-size: 26px;
      font-weight: 600;
      margin-bottom: 16px;
      color: ${theme.eventCardBackgroundColor === "#ffffff"
        ? "#323232"
        : "#ffffff"};
    `
  };
  return (
    <div className={styles.wrapper}>
      {groups.map(tourGroup => {
        const backgroundImage =
          tourGroup.image && tourGroup.image.url ? tourGroup.image.url : "";
        const imageContainer = css`
          width: 100%;
          height: 220px;
          border-radius: 4px;
          background: url(${backgroundImage}) center center / cover no-repeat
            rgb(238, 238, 238);
        `;
        const tokenLink = token ? `token=${token}` : "";
        const tourGroupLink = preview
          ? `/tours/${slug}/${tourGroup._id}?preview=true&${tokenLink}`
          : `/tours/${slug}/${tourGroup._id}?${tokenLink}`;
        return (
          <div className={styles.container}>
            <div className={imageContainer} />
            <div className={customStyles.contents}>
              <div className={customStyles.title}>{tourGroup.name}</div>
              <a href={tourGroupLink}>
                <Button tourTheme={theme} type="primary">
                  Explore
                </Button>
              </a>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TourGroup;



// WEBPACK FOOTER //
// ./routes/tours/TourGroup.js